<template>
  <div class="pc-class">
    <div class="pc-class-title">
      <h2>山西城市数据管理</h2>
    </div>
    <El-button v-if="!isEditting" @click="isEditting = true" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="isEditting = false" class="edit-btn"
      >完成</El-button
    >
    <!-- 分类签管理 -->
    <div class="pc-class-manage">
      <ul>
        <li
          v-for="(item, id) in cityData"
          :key="id"
          :class="selectedCity == item.id ? 'managerClass' : ''"
          @click="changeCity(item)"
        >
          <span
            >{{ item.english_name ? item.english_name : "" }}
            {{ item.english_name && item.chinese_name ? "/" : "" }}
            {{ item.chinese_name ? item.chinese_name : "" }}
          </span>
        </li>
      </ul>
    </div>
    <div class="data-list">
      <div v-for="item in indicator" :key="item.id" class="data-item">
        <p class="name">{{ item.name }}</p>
        <p
          class="value"
          @click="edit(item)"
          v-if="!item.isEditting || !isEditting"
        >
          {{ item.value }}
          <span class="el-icon-edit" v-if="isEditting"></span>
        </p>
        <div class="input" v-if="item.isEditting && isEditting">
          <el-input-number
            class="input-number"
            v-model.number="item.value"
            size="small"
            placeholder="value"
            :min="1"
            :max="20"
          ></el-input-number>
          <p class="el-icon-check" @click="changeValue(item)"></p>
        </div>
      </div>
    </div>
    <p v-if="indicator.length != 0" class="total">
      总分:{{
        indicator.reduce((perv, cur) => {
          return perv + Number(cur.value);
        }, 0)
      }}
    </p>
    <div id="radar-echart" class="radar-chart"></div>
  </div>
</template>
<script>
import { city_Api } from "../../../../apis/tools.api";
import {
  getCityData_Api,
  createCityData_Api,
  updateCityData_Api,
  deleteCityData_Api,
} from "../../../../apis/heritage.api";

export default {
  components: {
    // DeleteDialog,
  },
  data() {
    return {
      isEditting: false,
      cityData: [],
      indicator: [],
      selectedCity: 24,
    };
  },
  mounted() {
    city_Api().then((res) => {
      this.cityData = res.data;
      console.log(res.data);
    });

    this.getCityData();
  },

  methods: {
    getCityData() {
      getCityData_Api(this.selectedCity).then((res) => {
        console.log(res.data);
        res.data.forEach((item) => {
          item.isEditting = false;
          item.max = 20;
        });
        this.indicator = res.data;
        console.log(this.indicator);

        this.createEcharts();
      });
    },
    changeValue(item) {
      let params = {
        city_data_id: item.id,
        city_id: this.selectedCity,
        name: item.name,
        value: item.value,
      };
      console.log(params);
      updateCityData_Api(params).then((res) => {
        if (res.code == "205") {
          this.$global.success(this, "修改成功！");
          this.getCityData();

          console.log(res);
        }

        // this.createEcharts();
      });
    },
    edit(item) {
      this.$set(item, "isEditting", true);
    },
    changeCity(item) {
      this.selectedCity = item.id;
      this.getCityData();
    },
    createEcharts(radarChartData) {
      let _this = this;
      var chartDom = document.getElementById("radar-echart");
      this.$echarts.init(chartDom).dispose();
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        grid: {
          top: 0,
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",

          formatter: function (params) {
            let relVal = params.name;
            let typeList = _this.indicator;
            for (let i = 0; i < params.data.value.length; i++) {
              relVal +=
                "<br/>" +
                typeList[i]["name"] +
                " : " +
                params.data.value[i] +
                " " +
                "分 " +
                "最大值:" +
                typeList[i]["max"];
            }
            return relVal;
          },
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        radar: {
          indicator: _this.indicator,
        },
        series: [
          {
            type: "radar",
            areaStyle: {},
            data: [
              {
                value: _this.indicator.map((item) => item.value),
                name: "City data",
              },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.radar-chart {
  margin: 0 auto;
  height: 680px;
  width: 680px;
}
.pc-class {
  box-shadow: $boxshadow;
  padding: 40px 35px 20px;
  margin-top: 40px;
  position: relative;
  .edit-btn {
    @include manage-button;
    position: absolute;
    top: 30px;
    right: 40px;
  }
  .pc-class-title {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    padding-bottom: 15px;
    > h2 {
      font-size: 20px;
      color: $mainTitle;
      align-self: flex-end;
    }
    .pc-search-btn {
      @include manage-button;
    }
  }
  .pc-class-manage {
    margin-top: 20px;
    .pc-class-manage-title {
      display: flex;
      height: 20px;
      h4 {
        font-size: 14px;
        color: $mainTitle;
      }
      .icon-area {
        margin-left: 10px;
        color: $timeBtn;
        cursor: pointer;
      }
      .icon-area:nth-of-type(2) {
        margin-left: 5px !important;
      }
      /deep/ .el-input {
        margin-top: 20px;
        width: auto;
      }
    }
    ul {
      margin-top: 10px;
      display: flex;
      li {
        cursor: pointer;
        min-width: 70px;
        text-align: center;
        padding: 8px 21px;
        border: 1px solid $universityBorder;
        background: $universityBackground;
        margin-right: 20px;
        margin-bottom: 20px;
        color: $timeBtn;
        font-family: $english;
        border-radius: 4px;
        .el-icon-close {
          margin-left: 5px;
        }
      }
      .add-topic {
        border: 1px dashed $timeBtn;
        background: none;
        cursor: pointer;
      }
      .managerClass {
        background: $universityBorder;
        color: white;
      }
    }

    ul {
      flex-wrap: wrap;
      li {
        margin-bottom: 20px;
        span {
          font-size: 14px;
        }
      }
    }

    .addType {
      margin-top: 10px;
      margin-bottom: 20px;
      cursor: pointer;
      .el-icon-circle-plus-outline {
        font-size: 20px;
        color: $blueBtna;
      }
      span {
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .data-list {
    border: 2px dotted $timeBtn;
    padding: 20px;
    justify-content: space-between;
    display: flex;
    .data-item {
      width: 20%;
      border-right: 2px dotted $timeBtn;
      p {
        text-align: center;
      }
      .name {
        margin-bottom: 10px;
        .el-icon-edit {
        }
      }
      .value {
        cursor: pointer;
        color: $lightenYellow;
        font-size: 20px;
      }

      .value:hover {
        .el-icon-edit {
          display: inline;
        }
      }
      .input {
        position: relative;
        margin: 0 auto;
        .input-number {
          display: block;
          margin: 0 auto;
        }
        .el-icon-check {
          position: absolute;
          top: 0px;
          border-radius: 50%;
          border: 1px solid $lightenYellow;
          left: 83%;
          width: 32px;
          line-height: 32px;
          font-size: 24px;
          cursor: pointer;
          color: $lightenYellow;
        }
        .el-icon-check:hover {
          color: white;
          background: $lightenYellow;
        }
      }
    }
    .data-item:nth-of-type(5) {
      border-right: none;
    }
  }
  .total {
    position: absolute;
    font-size: 20px;
    font-weight: 600;
    color: $timeBtn;
    top: 360px;
    left: 50px;
  }
}

.el-dialog__body {
  display: flex;
  justify-content: center;
}
/deep/ .el-dialog {
  width: 31%;
  box-shadow: $boxshadow;
  border-radius: 4px;
  .title {
    display: flex;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      font-weight: 600;
      line-height: 40px;
      flex-shrink: 0;
      margin-right: 20px;
    }
  }
  .el-dialog__footer {
    padding: 10px 25% 30px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: space-around;
      .el-button--default:hover {
        background: $base-color;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
      .el-button--default:hover {
        span {
          color: $blueBtna;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/CityMenagement.vue